export const objectEntries = (r) => Object.entries(r);
